var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "page-title pull-left" }, [
      _c("h2", { staticClass: "entry-title" }, [
        _vm.getPathName("booking")
          ? _c("span", [_vm._v(_vm._s(_vm.booking[_vm.getCurrentLocale]))])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("services")
          ? _c("span", [_vm._v(_vm._s(_vm.services[_vm.getCurrentLocale]))])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("rebooking")
          ? _c("span", [_vm._v(_vm._s(_vm.rebooking[_vm.getCurrentLocale]))])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("mybookings")
          ? _c("span", [_vm._v(_vm._s(_vm.mybookings[_vm.getCurrentLocale]))])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("flightplan")
          ? _c("span", [_vm._v(_vm._s(_vm.flightplan[_vm.getCurrentLocale]))])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("pressreleases")
          ? _c("span", [
              _vm._v(_vm._s(_vm.pressreleases[_vm.getCurrentLocale])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("career")
          ? _c("span", [_vm._v(_vm._s(_vm.career[_vm.getCurrentLocale]))])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("infos-luggage")
          ? _c("span", [
              _vm._v(_vm._s(_vm.infos_luggage[_vm.getCurrentLocale])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("infos-dangerous-goods")
          ? _c("span", [
              _vm._v(_vm._s(_vm.infos_dangerous_goods[_vm.getCurrentLocale])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("infos-prohibited-items")
          ? _c("span", [
              _vm._v(_vm._s(_vm.infos_prohibited_items[_vm.getCurrentLocale])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("infos-additional-services")
          ? _c("span", [
              _vm._v(
                _vm._s(_vm.infos_additional_services[_vm.getCurrentLocale])
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("infos-serviceonboard")
          ? _c("span", [
              _vm._v(_vm._s(_vm.infos_serviceonboard[_vm.getCurrentLocale])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("infos-seat-reservation")
          ? _c("span", [
              _vm._v(_vm._s(_vm.infos_seat_reservation[_vm.getCurrentLocale])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("infos-fare-conditions")
          ? _c("span", [
              _vm._v(_vm._s(_vm.infos_fare_conditions[_vm.getCurrentLocale])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("infos-complaints")
          ? _c("span", [
              _vm._v(_vm._s(_vm.infos_complaints[_vm.getCurrentLocale])),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getPathName("infos-group-booking")
          ? _c("span", [
              _vm._v(_vm._s(_vm.infos_group_booking[_vm.getCurrentLocale])),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "breadcrumbs pull-right" }, [
      _c("li", [_c("a", { attrs: { href: "#" } }, [_vm._v("HOME")])]),
      _vm._v(" "),
      _c("li", { staticClass: "active" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }